<template>
    <client-page>
        <template v-if="!isLoaded">
            <v-sheet class="d-flex justify-center align-center">
                <v-progress-circular class="my-60" indeterminate size="50" width="5" />
            </v-sheet>
        </template>

        <template v-else-if="work">
            <v-container>
                <v-row>
                    <v-col cols="12" sm="5" xl="7">
                        <div class="pr-xl-14">
                            <auction-work-imgs :imgs="work?.imgs" />
                            <!-- S: PC버전 -->
                            <div class="d-none d-md-block font-size-16 grey-68--text mt-100">
                                <div class="mb-12 mb-md-22">
                                    <h5 class="font-size-20 font-size-md-24 font-weight-medium font-notoserif primary--text mb-4">작품정보</h5>
                                    <v-divider class="primary"></v-divider>
                                </div>
                                <div class="pb-22 pb-md-44">
                                    <div v-html="work?.content" style="white-space: pre-line" />
                                    <br />
                                    <p v-if="work?.author?.content" class="font-size-16 font-size-md-18 font-weight-bold primary--text mb-4">작가설명</p>
                                    <div v-html="work?.author?.content" style="white-space: pre-line" />
                                </div>
                                <v-divider class="primary"></v-divider>
                            </div>
                            <!-- E: PC버전 -->
                        </div>
                    </v-col>

                    <v-col cols="12" sm="7" xl="5">
                        <div class="pl-xl-44">
                            <div class="primary--text">
                                <div>
                                    <div class="d-flex justify-space-between">
                                        <strong class="font-size-14 font-size-md-16 font-weight-bold">LOT. {{ work?.lot }}</strong>
                                        <v-spacer />
                                        <auction-work-navigation v-bind="{ work }" />
                                    </div>
                                    <div class="mt-16 mt-md-26">
                                        <strong class="font-size-22 font-size-md-32 font-weight-medium font-notoserif">{{ work?.author?.name?.ko }}</strong>
                                        <!-- <span class="font-size-14 font-weight-light grey-68--text pl-8 pl-md-10">{{ work?.author?.nameTag?.en }}</span> -->
                                        <span class="font-size-14 font-weight-light grey-68--text pl-8 pl-md-10">{{ work?.author?.name?.en }}</span>
                                        <span class="font-size-14 font-weight-light grey-68--text pl-8 pl-md-10">b. {{ work?.author?.bornAt?.toDate?.()?.split?.("-")?.[0] }}</span>
                                        <span class="font-size-14 font-weight-light grey-68--text pl-8 pl-md-10">{{ work?.author?.country?.en }}</span>
                                    </div>
                                    <div class="mt-8 mt-md-12">
                                        <span class="tit tit--sm font-notoserif">{{ work?.subject }}</span>
                                    </div>
                                    <div class="mt-2 mt-md-4">
                                        <span class="font-size-14 font-size-md-16 grey-68--text">{{ work?.year }} ㅣ {{ work?.material }} ㅣ {{ work?.dimensionCodeTag }}</span>
                                    </div>
                                </div>

                                <template v-if="isProgram">
                                    <v-divider class="grey-da mt-20 mt-md-34"></v-divider>
                                    <div class="font-size-14 font-size-lg-16 py-12 py-md-18">
                                        <v-row no-gutters align="baseline">
                                            <v-col cols="2">
                                                <span>추정가</span>
                                            </v-col>
                                            <v-col cols="10">
                                                <div class="grey-68--text pl-sm-12">KRW {{ work?.price_estimated?.from?.format?.() }} ~ {{ work?.price_estimated?.to?.format?.() }}</div>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters align="baseline" class="mt-6 mt-md-8">
                                            <v-col cols="2">
                                                <span>시작가</span>
                                            </v-col>
                                            <v-col cols="10">
                                                <div class="grey-68--text pl-sm-12">KRW {{ work?.price_auction?.from?.format?.() }}</div>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters align="baseline" class="mt-6 mt-md-8">
                                            <v-col cols="2">
                                                <span>현재가</span>
                                            </v-col>
                                            <v-col cols="10">
                                                <div class="grey-68--text pl-sm-12">KRW {{ work?.price_auction?.current?.format?.() }}</div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <v-divider class="grey-da"></v-divider>

                                    <div class="font-size-14 font-size-lg-16 py-12 py-md-18">
                                        <v-row no-gutters align="baseline">
                                            <v-col cols="2">
                                                <span>응찰횟수</span>
                                            </v-col>
                                            <v-col cols="10">
                                                <div class="d-flex flex-wrap align-center">
                                                    <div class="grey-68--text pl-sm-12 pr-10 pr-lg-18">
                                                        <strong class="primary--text">{{ (work?._bids || []).length }}</strong> 회
                                                    </div>
                                                    <auction-bids :bids="bids" @refresh="init(true)">
                                                        <template #activator="{attrs,on}">
                                                            <v-btn v-bind="attrs" v-on="on" outlined small height="26" color="grey-cb"><span class="primary--text">응찰기록보기</span></v-btn>
                                                        </template>
                                                    </auction-bids>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters align="baseline" class="mt-6 mt-md-8">
                                            <v-col cols="2">
                                                <span>응찰기간</span>
                                            </v-col>
                                            <v-col cols="10">
                                                <div class="grey-68--text pl-sm-12">{{ duration_auction }}</div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <v-divider class="grey-da"></v-divider>

                                    <div class="font-size-14 font-size-lg-16 py-12 py-md-18">
                                        <v-row no-gutters align="baseline" class="font-weight-medium">
                                            <v-col cols="2">
                                                <span>남은시간</span>
                                            </v-col>
                                            <v-col cols="10">
                                                <div class="pl-sm-12"><auction-work-until :work="work" /></div>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <v-divider class="primary"></v-divider>
                                    <v-row no-gutters>
                                        <v-col>
                                            <auction-commission :work="work">
                                                <template #activator="{attrs,on}">
                                                    <v-btn v-bind="attrs" v-on="on" large block text>낙찰 수수료<i class="icon icon-help-circle-outline ml-6 ml-md-8"></i></v-btn>
                                                </template>
                                            </auction-commission>
                                        </v-col>
                                        <v-col cols="auto">
                                            <div class="h-100 py-6">
                                                <v-divider vertical class="primary"></v-divider>
                                            </div>
                                        </v-col>
                                        <v-col>
                                            <auction-units>
                                                <template #activator="{attrs,on}">
                                                    <v-btn v-bind="attrs" v-on="on" large block text>경매 호가표<i class="icon icon-help-circle-outline ml-6 ml-md-8"></i></v-btn>
                                                </template>
                                            </auction-units>
                                        </v-col>
                                    </v-row>
                                    <v-divider class="primary"></v-divider>
                                    <!-- <v-row no-gutters>
                                        <v-col>
                                            <auction-delivery>
                                                <template #activator="{attrs,on}">
                                                    <v-btn v-bind="attrs" v-on="on" large block text>예상 배송비<i class="icon icon-help-circle-outline ml-6 ml-md-8"></i></v-btn>
                                                </template>
                                            </auction-delivery>
                                        </v-col>
                                        <v-col cols="auto">
                                            <div class="h-100 py-6">
                                                <v-divider vertical class="primary"></v-divider>
                                            </div>
                                        </v-col>
                                        <v-col>
                                            <auction-services>
                                                <template #activator="{attrs,on}">
                                                        <v-btn v-bind="attrs" v-on="on" large block text>설치 및 보관<i class="icon icon-help-circle-outline ml-6 ml-md-8"></i></v-btn>
                                                </template>
                                            </auction-services>
                                        </v-col>
                                    </v-row>
                                    <v-divider class="primary"></v-divider> -->
                                    <div class="mt-16 mt-md-20">
                                        <auction-actions v-bind="{ work, bids }" @refresh="init(true)">
                                            <template #activator="{attrs,on}">
                                                <v-btn v-bind="attrs" v-on="on" block x-large color="primary" :disabled="work?.isAuctionEnded">
                                                    <template v-if="work?.isAuctionEnded">경매종료</template>
                                                    <template v-else>응찰하기</template>
                                                </v-btn>
                                            </template>
                                        </auction-actions>
                                    </div>
                                </template>

                                <div class="mt-20 mt-md-40">
                                    <v-divider class="grey-da"></v-divider>
                                    <auction-work-classifications :classifications="work?.classifications" />
                                    <v-divider class="grey-da"></v-divider>
                                </div>

                                <template v-if="isPrivate">
                                    <div class="mt-20 mt-md-40">
                                        <v-btn block x-large color="primary" :to="`/form/private-sale?_work=${work._id}`">문의하기</v-btn>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </v-col>

                    <!-- S: Mobile버전 -->
                    <v-col cols="12" md="7" class="d-md-none">
                        <div class="font-size-16 grey-68--text mt-10">
                            <div class="mb-12 mb-md-22">
                                <h5 class="font-size-20 font-size-md-24 font-weight-medium font-notoserif primary--text mb-4">작품정보</h5>
                                <v-divider class="primary"></v-divider>
                            </div>
                            <div class="pb-22 pb-md-44">
                                <div v-html="work?.content" style="white-space: pre-line" />
                                <br />
                                <p v-if="work?.author?.content" class="font-size-16 font-size-md-18 font-weight-bold primary--text mb-4">작가설명</p>
                                <div v-html="work?.author?.content" style="white-space: pre-line" />
                            </div>
                            <v-divider class="primary"></v-divider>
                        </div>
                    </v-col>
                    <!-- S: Mobile버전 -->
                </v-row>
            </v-container>
        </template>

        <template v-else>
            <v-container>
                <div class="tit tit--sm text-center pt-80">데이터가 없습니다.</div>
            </v-container>
        </template>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import AuctionBids from "@/components/client/ko/auction/auction-bids.vue";
import AuctionUnits from "@/components/client/ko/auction/auction-units.vue";
import AuctionActions from "@/components/client/ko/auction/auction-actions.vue";
import AuctionWorkImgs from "@/components/client/ko/auction/auction-work-imgs.vue";
import AuctionDelivery from "@/components/client/ko/auction/auction-delivery.vue";
import AuctionServices from "@/components/client/ko/auction/auction-services.vue";
import AuctionWorkUntil from "@/components/client/ko/auction/auction-work-until.vue";
import AuctionCommission from "@/components/client/ko/auction/auction-commission.vue";
import AuctionWorkClassifications from "@/components/client/ko/auction/auction-work-classifications.vue";

import api from "@/api";
import { WORK_AUCTION_MODES } from "@/assets/variables";
import AuctionWorkNavigation from "@/components/client/ko/auction/auction-work-navigation.vue";

export default {
    components: {
        ClientPage,
        AuctionBids,
        AuctionUnits,
        AuctionActions,
        AuctionWorkImgs,
        AuctionDelivery,
        AuctionServices,
        AuctionWorkUntil,
        AuctionCommission,
        AuctionWorkClassifications,
        AuctionWorkNavigation,
    },
    props: {
        _work: { type: String },
    },
    data() {
        return {
            isLoaded: false,

            work: null,
            bids: [],
        };
    },
    computed: {
        duration_auction() {
            let { duration_auction: { startsAt, endsAt } = {} } = this.work || {};
            if ((startsAt, endsAt)) return `${startsAt?.toDateTime?.()} ~ ${endsAt?.toDateTime?.()}`;

            [{ duration: { startsAt, endsAt } = {} }] = [this.work?.program || {}];
            return `${startsAt?.toDateTime?.()} ~ ${endsAt?.toDateTime?.()}`;
        },
        isProgram() {
            return this.work?.mode_auction == WORK_AUCTION_MODES.PROGRAM.value;
        },
        isPrivate() {
            return this.work?.mode_auction == WORK_AUCTION_MODES.PRIVATE.value;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        _work() {
            this.init();
        },
    },
    methods: {
        async init(isLoaded = false) {
            this.isLoaded = isLoaded;
            const { work } = await api.v1.auction.works.get({ _id: this._work });
            this.work = work;
            const { _work } = this;
            const { bids } = await api.v1.auction.works.bids.gets({ _work });
            this.bids = bids;
            if (!this.isLoaded) this.isLoaded = true;
        },
    },
};
</script>
